var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h3',{staticClass:"x5-modal-error"},[_vm._v("⚠️ There was a problem loading this modal content.")])}
var staticRenderFns = []

export { render, staticRenderFns }